import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Question, Option } from '../../../../../classes';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { focusOn } from '../../../functions/focus-on.fn';
import { scrollTo } from '../../../functions/scroll-to.fn';
import { DndDropEvent } from "ngx-drag-drop";

@Component({
  template: '',
})
export class QuestionComponent implements OnInit {
  @Input() question:Question;
  @Input() questionsFormGroup:FormGroup;
  constructor(
    protected cdRef:ChangeDetectorRef,
  ) { 
  }

  questionFormGroup:FormGroup;
  subscriptions:Subscription[] = [];
  questionId:string;
  ngOnInit() {
    this.createFormGroup();
    this.subscriptions.push(this.question.onContentUpdate.subscribe(()=>this.refreshView()));
  } 
  ngOnDestroy () {
    this.removeFormGroup();
    this.subscriptions.forEach(sub=>sub.unsubscribe());
  }
  refreshView () {
    this.cdRef.detectChanges()
  } 
  addSubQuestion () {
      let subQuestion = this.question.survey.addSubQuestion(this.question);
      setTimeout(()=>{
        focusOn(`#question_${subQuestion.id} textarea`);
        scrollTo(`#question_${subQuestion.id} textarea`, 300);
      })      
  }
  addTextOption () {
      let textOption = this.question.addOption({text:'ê¸°í', type:'text'});
      setTimeout(()=>{
        focusOn(`#option_${textOption.id} textarea`);
        scrollTo(`#option_${textOption.id} textarea`, 300);
      })      
  }
  onDrop( event:DndDropEvent ) {
    let option_id:Option = event.data;
    let option = this.question.getOptions({id:option_id})[0];
    if (option) {
      let pos_o = option.priority;
      let pos_n = event.index;
  
      if (pos_o < pos_n ) { // down
        pos_n--;
      } else if (pos_o > pos_n) { // up
        pos_n;
      }
      option.priority = pos_n;
    }
  }
  TrackByFn (index:number, option:Option) {
    return option.id;
  }
  private createFormGroup() {
    if (this.questionsFormGroup) {
      this.questionId = this.question.id;
      this.questionFormGroup = new FormGroup({options:new FormGroup({})});
      this.questionsFormGroup.setControl(this.questionId, this.questionFormGroup);
    }
  }
  private removeFormGroup() {
    if (this.questionsFormGroup) {
      this.questionsFormGroup.removeControl(this.questionId);
    }

  }
}
